module.exports = __webpack_public_path__ + "img/default-profile-icon.d40830f2.jpg";